import { useGoogleLogin, TokenResponse } from "@react-oauth/google";
import GoogleLogoSmall from "@/app/assets/icons/google-logo-small";
import { useEffect, useState } from "react";
import { authService } from "@/app/api/service/auth";
import { ToastContainer, toast } from 'react-toastify';
// import { initBranch, trackEvent } from "@/app/utils/branchio";
import { setAnalyticsEvent } from "@/app/utils/SetAnalyticsEvent";
import { useCleverTapEvents } from "@/app/hooks/use-clevertap";
type TGoogleSignUp = {
    type?: string;
    cookieEnabled?: boolean;
    handleGoogleSignUp: () => void;
    urlRefCode: string;
};

/* type GSignUpDetails = {
    access_token?: string;
    authuser?: string;
    expires_in?: number;
    hd?: string;
    prompt?: string;
    scope?: string;
    token_type?: string;
}; */

export interface GUserProfile {
    email?: string;
    email_verified?: boolean;
    family_name?: string;
    given_name?: string;
    hd?: string;
    name?: string;
    picture?: string;
    sub?: string;
    accessToken?: string;
    refCode?: string;
}

function GoogleSignUp({ /* type, cookieEnabled, */ handleGoogleSignUp, urlRefCode }: TGoogleSignUp) {
    const [gAccessToken, setGAccessToken] = useState<string>("");
    const [userDetails, setUserDetails] = useState<GUserProfile>({});
    const { cleverTapTrackEvent } = useCleverTapEvents();

    // Helper function to show toast with proper types

    useEffect(() => {
        if (gAccessToken && Object.keys(userDetails).length) {
            verifyEmail(userDetails);
        }
    }, [userDetails]);

    const handleGoogleLoginClick = () => {
        cleverTapTrackEvent('Signup_Gmail', {});
        // initBranch().then(() => {
        //     trackEvent('Signup_Gmail');
        // }).catch(error => console.error('Error initializing Branch:', error));
        setAnalyticsEvent(window.location.origin, "Signup_Gmail");
        initiateGoogleLogin();
    }

    const initiateGoogleLogin = useGoogleLogin({
        onSuccess: (tokenResponse: TokenResponse) => {
            if (tokenResponse && !tokenResponse.error) {

                setGAccessToken(tokenResponse.access_token);
                authService
                    .fetchGoogleAuthUserDetails(tokenResponse.access_token)
                    .then((response) => response.json())
                    .then((profile: GUserProfile) => {
                        if (profile && Object.keys(profile).length) {
                            setUserDetails(profile);
                        }
                    });
            }
        },
        onError: (res) => {
            // console.log("google signup error: ", res);
            if (res?.error) {
                toast.error('Google Sign-In was cancelled. Please try again.');
            }
        },
    });

    const verifyEmail = async (profile: GUserProfile) => {
        // debugger;
        // setIsSubmitting(true);
        const userDetails = profile;
        userDetails.accessToken = gAccessToken;
        await authService.verifyEmail(String(userDetails.email)).then((result) => {
            if (result && result.success && result.message === 1) {
                registerGmail(userDetails);
            }
            if (result && result.success && result.message === 2) {
                toast.warning('Registration Failed, Email already registered, please try with different email.');
            }
        });
    };

    // const loginByGmail = async (GUserProfile: GUserProfile) => {
    //     // debugger;
    //     const request = {
    //         email: GUserProfile.email,
    //         accessToken: GUserProfile.accessToken,
    //     };

    //     // setIsSubmitting(true);
    //     const result = await authService.login(request).then((response) => {
    //         return response;
    //     });
    //     if (result && result.success && result.message === 1) {
    //         // redirects to questionnaier page.
    //         /* const userSwitch = await gUserSwitch();
    //         if (userSwitch) { */
    //             handleGoogleSignUp();
    //         /* } */
    //     } else if (result && result.error && !result.error.success) {
    //         // This case will never happne as this is signup case. --check
    //     }
    //     // setIsSubmitting(false);
    // };

    const registerGmail = async (GUserProfile: GUserProfile) => {
        // debugger;
        const result = await authService.registerForGmail({...GUserProfile, refCode: urlRefCode}).then((response) => {
            return response;
        });
        if (result && result.success && result.message === 1) {
            // redirects to questionnaier page.
            /* const userSwitch = await gUserSwitch();
            if (userSwitch) { */
                handleGoogleSignUp();
            /* } */
        } else {
            console.log("Register Gmail: ", "Something went wrong, Please try again later!");
        }
        // setIsSubmitting(false);
    };

    /* const gUserSwitch = async () => {
        debugger;
        const result = await authService.switchUser().then((res) => {
            return res;
        });
        if (result && result.email) {
            const details = await authService.getUserDetails().then((res) => {
                debugger;
                return res;
            });
            return details;
        }
    }; */

    return (
        <div
            className="mb-9 inline-flex w-full cursor-pointer items-center justify-start rounded-full border border-neutralOpacityDark-10 px-s9 py-s7 text-lg md:mb-8"
            onClick={() => handleGoogleLoginClick()}
        >
            <GoogleLogoSmall className="text-white hover:text-black" />
            <span className="ml-3 text-lg font-medium leading-[29.52px] tracking-[-0.18px] text-neutral-900">
                Continue with Google
            </span>
            <ToastContainer />
        </div>
    );
}

export default GoogleSignUp;
